import React from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Seasons from "../components/site/Seasons";
import FinalCTA from "../components/site/FinalCTA";
import CookiesNotice from "../components/site/CookiesNotice";
import LangAttrSync from "../components/site/LangAttrSync";
import RegistrationPopup from "../components/site/RegistrationPopup";
import { Toaster } from "sonner";

export default function Home() {
  return (
    <div className="bg-white text-black min-h-screen" data-testid="home-page">
      <LangAttrSync />
      <Header />
      <main>
        <Hero />
        <Seasons />
        <FinalCTA />
      </main>
      <CookiesNotice />
      <RegistrationPopup />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #000",
            background: "#fff",
            color: "#000",
            fontFamily: "Manrope, sans-serif",
            fontWeight: 600,
          },
        }}
      />
    </div>
  );
}
